import React from "react";
import { DAY_SELECT } from "../../../constants";

export const DaysSelect = (props) => {
  return (
    <select
      className="filter-selector"
      onChange={(e) => {
        props.changeGlobalDays(e.target.value)
        props.filterFromTo && props.filterFromTo({
          from: undefined,
          to: undefined,
        })
      }}
    >
      {DAY_SELECT.map((item) => {
        return (
          <option name={item.name} value={item.days} key={item.name}>
            {item.name}
          </option>
        );
      })}
    </select>
  );
};
